export default __webpack_public_path__ + "static/media/Arrow-curved.0c462db2.svg";